export default __webpack_public_path__ + "static/media/skill_3.c626ea98.png";